// src/utils/moneyUtils.js

/**
 * Formata um valor em centavos inteiros para uma string monetária em Real (BRL).
 * Ex: 150050 => "R$ 1.500,50"
 * @param {number} cents - Valor em centavos
 * @returns {string} Valor formatado em BRL
 */
export const formatCentavos = (cents) => {
  const value = (cents || 0) / 100;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

/**
 * Converte um valor numérico ou string monetária para centavos inteiros.
 * Ex: "R$ 1.500,50" => 150050
 * Ex: 1500.5 => 150050
 * @param {string|number} val - Valor a ser convertido
 * @returns {number} Valor em centavos inteiros
 */
export const parseCentavos = (val) => {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") {
    return Math.round(val * 100);
  }

  // Se for string, limpa para extrair o valor decimal
  let cleanStr = String(val).trim();
  if (!cleanStr) return 0;

  // Remove símbolos monetários comuns e espaços
  cleanStr = cleanStr.replace(/R\$/g, "").replace(/\s/g, "");

  // Detecta se o separador decimal é vírgula ou ponto
  // Formato brasileiro comum: 1.500,50
  if (cleanStr.includes(",") && cleanStr.includes(".")) {
    // Remove pontos de milhar e substitui a vírgula decimal por ponto
    cleanStr = cleanStr.replace(/\./g, "").replace(",", ".");
  } else if (cleanStr.includes(",")) {
    // Apenas vírgula: ex "1500,50"
    cleanStr = cleanStr.replace(",", ".");
  }

  const parsedFloat = parseFloat(cleanStr);
  if (isNaN(parsedFloat)) return 0;

  return Math.round(parsedFloat * 100);
};
